<template>
  <div>
    <div v-if="showloading">

      <loader-appie/>

    </div>

<!--    <sidebar-home-one :sidebar="sidebar" :side="SideMenu" @toggleSidebar="toggleSidebar" :menuItems="navs"/>-->


<!--    <header-home-two @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"-->
<!--                     :menuItems="navs"/>-->


<!--    <section class="appie-testimonial-2-area mt-100 mb-90" id="testimonial">-->
    <section class="appie-testimonial-2-area" id="testimonial">

<!--      <div class="container maincard" v-if="!showloading" >-->
      <div class="container " v-if="!showloading" >
        <BackButton />
        <div class="row">
          <div class="col-md-3 whitebackground menudiv" >
            <menubar @toggleSidebar="toggleSidebar" :side="SideMenu" :titleWordd="titleWord" :custCare="customerCare"
                     :menuItems="navs"/>
          </div>
          <div class="col-md-9  graybackground contentdiv" >
            <div class="row mt-2">
              <div class="">
                <Commonprofile/>
              </div>
              <div class="col-lg-12 ">

                <div class="row ">
                  <div class="mt-2" style="text-align: center" >
                    <span v-html="title"></span>
                  </div>


                </div>

                <div class="row mt-1 ">
                  <!--                <div class="card" v-if="list.groupCard" :style="{backgroundColor:list.groupCard[0].bgColor,width: '90%',margin: 'auto'}" >-->

                  <div class="row mt-2">
                    <div class="col-4 col-sm-12 col-lg-4" v-for="(multiCardcount,index) in list.multiCard"
                         :key="index">
                      <div class="card" style="width: 100%" v-if="multiCardcount.visible==1" @click="countmpage(multiCardcount.activity,multiCardcount.url)">
                        <div class="card-body p-0">
                          <p><span v-html="multiCardcount.title"></span></p>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>

                <div class="col-12 col-sm-12 col-lg-12 mt-2  temp_10_space">
                  <!--                <div v-if="list.groupCard">-->
                  <div class="row">
                    <div class="col-12 col-md-12 col-lg-12">
                      <div v-for="(groupCardlist,index) in list.groupCard" :key="index">
                        <div class="" style="background: #4D5BE1">
                          <div class="p-1">

                            <div class="row">

                              <div class="text-end">

                                  <div v-for="(buttonViewData,index) in buttonView" :key="index"  style="display: inline-block;">
                                    <div v-if="buttonViewData.visible == '1'">
                                      <div v-if="index == 0">
                      <span class="badge rounded-pill bg-dark" @click="EditJob(buttonViewData.url,buttonViewData.activity)"   style="cursor: pointer;"><span
                          v-html="buttonViewData.title"
                          :style="{backgroundColor:bgColor,fontSize: '0.7rem',padding: '2px'}"></span></span>
                                      </div>
                                      <div v-else>

                                        <img :src="buttonViewData.icon[0]" alt="" class=""
                                             :style="{ width: '20% !important', border: buttonViewData.value == 1 ? '2px solid blue' : 'none' }"
                                             @click="shortlisturl(buttonViewData.action.url,index)">
                                      </div>

                                    </div>
                                  </div>
                                  <br>
                                  <span v-if="istoastMessage" class="shortlist-toaster">{{toastMessage}}</span>


                              </div>

                            </div>
                            <div class="row">
                              <div class="col-3  col-md-2 col-lg-2  text-center" >
                                <img :src="groupCardlist.image" class="logosize">


                              </div>
                              <div class="col-9  col-md-10 col-lg-10 ">

                                <p class="textleft  " v-html="cleanName(groupCardlist.jobtitle)"></p>

                                <span class="textleft " v-html="groupCardlist.employer"></span>    <span class="badge rounded-pill whitebackground badgestyle  text-dark"><span
                                  v-html="groupCardlist.jobType"></span></span>
                                <p class="textleft fontboldwight" v-html="groupCardlist.joblocation"></p>
                                <!--                          <p v-html="truncateHTML(groupCardlist.joblocation, 15)"></p>-->

                                <span class="badge rounded-pill bg-light text-dark"
                                      v-html="groupCardlist.noofvancancy"></span>

                              </div>
                            </div>


                            <div class="row mt-2">
                              <div class="col-12 col-nd-4 col-lg-4 mb-2" v-for="(MulticardData,index) in groupCardlist.multiCard"
                                   :key="index">
                                <div class="multigardgrid" style="width: 100%" v-if="MulticardData.visible==1">

                                    <p><span v-html="MulticardData.title"></span></p>

                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-12 col-md-12 col-lg-12">
                      <div class="card mb-2 mt-2">
                        <div class="card-body">

                          <div class="row mt-2 ">

                            <!--                <div class="card" v-if="list.groupCard" :style="{backgroundColor:list.groupCard[0].bgColor,width: '90%',margin: 'auto'}" >-->
                            <div v-for="(CommunicationInfo,index) in list.singleCard" :key="index" class="col-12 col-md-6 col-lg-6 mb-2">
                              <!--                    <div class="card mb-2">-->
                              <!--                      <div class="card-body">-->
                              <p v-html="CommunicationInfo.title" style="text-align: left"></p>

                              <div v-for="(CommunicationInfoData,index) in CommunicationInfo.list" :key="index" class="row">
                                <div class="col-md-4">
                                  <p v-html="CommunicationInfoData.title" style="text-align: left"></p>
                                </div>
                                <div class="col-md-8">
                                  <p v-html="CommunicationInfoData.content ?CommunicationInfoData.content:'------'" style="text-align: left"></p>
                                </div>

                                <!--                        </div>-->
                                <!--                      </div>-->
                              </div>

                            </div>

                          </div>
                          <div class="row mt-2 ">
                            <!--                <div class="card" v-if="list.groupCard" :style="{backgroundColor:list.groupCard[0].bgColor,width: '90%',margin: 'auto'}" >-->
                            <div v-for="(proofdata,index) in list.proof" :key="index">
                              <!--                    <div class="card mb-2">-->
                              <!--                      <div class="card-body">-->
                              <p v-html="proofdata.title" style="text-align: left"></p>
                              <div class="row">
                                <div v-for="(proofdatalist,index) in proofdata.list" :key="index" class="col-md-4 col-12">

                                  <p v-html="proofdatalist.title" style="text-align: left"></p>
                                  <img :src="proofdatalist.image"  style="width: 100px;height: 100px"/>
                                </div>
                              </div>
                              <!--                      </div>-->
                              <!--                    </div>-->


                            </div>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>




                  <div v-if="openCall">
                    <!--                <button>{{navButton}}</button>-->
                    <div v-if="navButton.visible == '1'">
                      <button type="button" class="btn"
                              :style="{backgroundColor:navButton.bgColor,fontSize:navButton.textSize}"
                              @click="callMobileNumber(navButton.value)"><span v-html="navButton.title"></span></button>
                    </div>
                  </div>
                </div>

                <div>

                </div>

              </div>
            </div>
          </div>
        </div>


        </div>

        <div>
          <b-modal id="modal-center1" centered title="BootstrapVue">
            <div class="row">
              <!-- First Card Row -->
              <div class="col-12 col-lg-12 col-md-12 mb-4" v-for="(customerCareData,index) in customerCare" :key="index">
                <span v-html="stripTags(customerCareData.label)"></span>


                <div class="card" >
                  <div class="card-body">
                    <div class="row align-items-center">
                      <div class="col-2 col-lg-2 col-md-2">
                        <div class="d-flex justify-content-center align-items-center h-100">
                          <i class="fa fa-phone flipped" style="background: white;" aria-hidden="true"></i>
                        </div>
                      </div>
                      <div class="col-8 col-lg-8 col-md-8">
                        <div class="d-flex flex-column justify-content-center h-100">
                          <span>{{ customerCareData.name }}</span>
                          <span v-html="customerCareData.description"></span>
                        </div>
                      </div>
                    </div>


                  </div>
                </div>
              </div>
            </div>
          </b-modal>
        </div>
    </section>

    <div class="back-to-top back-to-top-2">
      <a href="#"><i class="fal fa-arrow-up"></i></a>
    </div>
    <!--====== APPIE BACK TO TOP PART ENDS ======-->
  </div>
</template>

<script>
import video_bg_thumb from "@/assets/images/video-thumb-1.jpg"
import hero_img from '@/assets/images/hero-thumb-3.png'
// import SidebarHomeOne from '../HomeOne/SidebarHomeOne.vue'
//
// import HeaderHomeTwo from '../HomePage/Header.vue'
import BackButton from '../HomePage/BackButton.vue';

import {callAxiosWithConfig} from "@/main";
import {right} from "core-js/internals/array-reduce";
import CryptoJS from 'crypto-js';
import LoaderAppie from '../LoaderAppie.vue'
import Menubar from "@/components/HomePage/menu.vue";
import Commonprofile from "@/components/HomePage/commonprofilediv.vue";

export default {
  props: {
    section_heading: {
      type: String,
    },
    more_heading: {
      type: String
    },
    description: {
      type: String
    },
    grid_items: {
      type: Array,
    }
  },
  components: {
    Commonprofile,
    Menubar,
    BackButton,
    // HeaderHomeTwo,
    LoaderAppie,
    // SidebarHomeOne,
  },
  data() {
    return {
      selectedIndex: null,
      istoastMessage:false,
      showloading:false,
      SideMenu: {},
      titleWord: '',
      customerCare: {},
      title: '',
      openCall: false,
      textSize: '',
      navButton: '',
      buttonView: [],
      singleCard: [],
      list: [],
      ListTitleData: [],
      ListButtonData: [],
      bgColor: '',
      template: '',
      urlData: '',
      ViewPosttitle: '',
      sidebar: false,
      navs: [
        {
          // name:'contact',
          name: 'Home',
          path: '/home-page'
        },
        {
          name: 'Profile',
          childrens: [
            {
              // name:'Home 1',
              name: 'Update KYC',
              path: '/'
            },
            {
              // name:'Home 2',
              name: 'Update Profile',
              path: '/home-two'
            },
            {
              // name:'Home 3',
              name: 'View Profile',
              path: '/home-three'
            },
            {
              // name:'Home 4',
              name: 'Viewed Profiles',
              path: '/home-four'
            },
            {
              // name:'Home 5',
              name: 'Change Mobile Number',
              path: '/home-five'
            },
            // {
            //   name:'Home 6',
            //   path:'/home-six'
            // },
            // {
            //   name:'Home 7',
            //   path:'/home-seven'
            // },
            // {
            //   name:'Home 8',
            //   path:'/home-eight'
            // },
          ],
        },
        // {
        //   name:'service',
        //   path:'/service-details'
        // },
        // {
        //   name:'pages',
        //   childrens:[
        //     {
        //       name:'About us',
        //       path:'/about-us'
        //     },
        //     {
        //       name:'Error',
        //       path:'/error'
        //     }
        //   ],
        // },
        // {
        //   name:'news',
        //   childrens:[
        //     {
        //       name:'News',
        //       path:'/news'
        //     },
        //     {
        //       name:'Single news',
        //       path:'/single-news'
        //     },
        //   ],
        // },
        {
          // name:'contact',
          name: 'Customer Care',
          path: '/contact'
        },
        // {
        //   // name:'contact',
        //   name:'Notification',
        //   path:'/notifi'
        // }
      ],
      hero_img: hero_img,
      video_bg_thumb: video_bg_thumb
    }
  },
  mounted() {
    document.addEventListener('scroll', this.topToBottom)
  },

  async created() {

    if (this.$route.query.page) {
      this.showloading=true;
      const pageurl = this.$route.query.page;
      const decryptedString = this.decryptUrl(pageurl);

      this.modifiedString=decryptedString;

      // alert(this.modifiedString);

      // this.EditId = this.$route.query.id;
      // this.decryptedValue = this.Decrypt(this.encryptedParam);
      // this.modifiedString = this.decryptedValue.replace(/-/g, '/');


    // console.log('dgdsdgsg')
    const ViewPostData = await callAxiosWithConfig(this.modifiedString, '', 'post');
    this.showloading=false;
    this.title = ViewPostData.title;
    this.buttonView = ViewPostData.buttonView;
    // console.log(this.buttonView)
    this.list = ViewPostData.list;
    if (this.modifiedString == 'jobspro/api/post/employee/SingleView') {
      this.openCall = true;
      this.navButton = ViewPostData.navButton;
    }

    this.SideMenu = JSON.parse(localStorage.getItem("SideMenu"));
    this.titleWord = JSON.parse(localStorage.getItem("titleWord"));
    this.customerCare = JSON.parse(localStorage.getItem("customerCare"));

    console.log(this.SideMenu)
    this.$emit("tempData", this.SideMenu);
    this.$emit("title", this.titleWord);
    this.$emit("customerCare", this.customerCare);

    }
  },

  methods: {

    verifyviewmsgtoaster(message) {
      // Set the message
      this.istoastMessage=true;
      this.toastMessage = message;
      setTimeout(() => {
        this.istoastMessage=false;
        this.toastMessage = ''; // Clear the message after 3 seconds

      }, 3000); // Adjust the duration as needed
    },

    cleanName(name) {
      let cleanname=name.replace(/\+/g, ' ');
      return decodeURIComponent(cleanname);
    },

    // cleanName(name) {
    //   if (name.startsWith('%')) {
    //     // If the name starts with '%', it's URL-encoded
    //     try {
    //       return decodeURIComponent(name);
    //     } catch (error) {
    //       console.error("Error decoding name:", error);
    //       return name; // Return original name if decoding fails
    //     }
    //   } else {
    //     // If the name doesn't start with '%', it's not URL-encoded
    //     // Replace '+' with space
    //     return name.replace(/\+/g, ' ');
    //   }
    // },
    async shortlisturl(url,indexvalue){


      const ViewPostData = await callAxiosWithConfig(url, '', 'post');
      // console.log(ViewPostData);

      if(ViewPostData.status == true){
        let toastmsg=ViewPostData.message;
        let value=ViewPostData.value;

       if(value == 1){
         this.$set(this.buttonView[indexvalue], 'value', 1);
       }
       else{
         this.$set(this.buttonView[indexvalue], 'value', 0);
       }
        this.verifyviewmsgtoaster(toastmsg);
      }
      else{
        let toastmsg=ViewPostData.message;
        this.verifyviewmsgtoaster(toastmsg);


      }

    },

    stripTags(html) {
      // Regular expression to remove HTML tags
      return html.replace(/<[^>]+>/g, '');
    },

    callMobileNumber(mobileNumber) {
      // Ensure the mobile number is valid
      if (mobileNumber) {
        // Use window.open with tel URI scheme to initiate a call
        window.open('tel:' + mobileNumber);
      } else {
        // Handle case where mobile number is not available
        console.error('Mobile number is not available');
      }
    },

    async EditJob(url,activity) {
      

      const encryptedString = this.encryptUrl(url);
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
     if (lastPart === 'Employer_Common_Webview_Activity') {

        await this.$router.push(`/plan-purchase?page=${encodeURIComponent(encryptedString)}`);
      }
      else{
        await this.$router.push(`/company-register?page=${encodeURIComponent(encryptedString)}`);
      }

      // Redirect to the company-register page with the encrypted URL
     
    },
    async countmpage(activity, url) {
      // alert(activity)
      // alert(url)
      const inputString = activity;
      const lastPart = inputString.split('.').pop();
      // alert(lastPart);
      this.urlData = url;
      if (lastPart === 'ViewCandidate_List') {
        const encryptedString = this.encryptUrl(url);
        await this.$router.push(`/viewed-employer-list?page=${encodeURIComponent(encryptedString)}`);
      }

    },


    encryptUrl(url) {
      const ciphertext = CryptoJS.AES.encrypt(url, 'secret key 123').toString();
      return ciphertext;
    },
    decryptUrl(ciphertext) {
      const bytes = CryptoJS.AES.decrypt(ciphertext, 'secret key 123');
      const originalUrl = bytes.toString(CryptoJS.enc.Utf8);
      return originalUrl;
    },

    Encrypt(str) {
      // return str.split('').map(char => char.charCodeAt(0)).join('-');
      return str.replace(/[a-zA-Z]/g, function (char) {
        // Replace each alphabetic character with its encrypted value
        const charCode = char.charCodeAt(0);
        const encryptedCharCode = charCode + 1; // You can use a different encryption logic
        return String.fromCharCode(encryptedCharCode);
      });
    },

    navigateToSamePage() {
      this.$router.go(-1);
    },

    Decrypt(str) {
      return str.replace(/[a-zA-Z]/g, function (char) {
        const charCode = char.charCodeAt(0);
        const decryptedCharCode = charCode - 1; // Decryption logic
        return String.fromCharCode(decryptedCharCode);
      });
    },

    right,
    topToBottom() {
      const result = document.querySelector('.back-to-top')
      if (document.body.scrollTop > window.innerHeight || document.documentElement.scrollTop > window.innerHeight) {
        result.style.display = "block";
      } else {
        result.style.display = "none";
      }
    },
    toggleSidebar() {
      this.sidebar = !this.sidebar
    },

  }

}
</script>

<style>
.appie-features-box-item {
  padding: 10px 12px 12px 10px;
}
.shortlist-toaster {

  padding: 2px;
  border-radius: 5px;
  border: 1px solid black;

  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
.appie-features-box-item.item-2:hover {
  border-color: unset;
}

.maincard {
  box-shadow: 0px 2px 5px 0px rgba(0, 0, 0, 0.3);
  padding: 20px 10px 10px 10px;
  width: 100%;
}

@media (min-width: 768px) {
  .maincard1 {
    width: 90% !important;
    margin: auto;
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .temp_10 {
    min-height: 100px;
    border: unset;
    width: 100%;
    border-radius: 10px;
  }

  .temp_10_space {
    margin-bottom: 30px;
  }

  .imageSize {
    width: 10%;
  }

}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media (min-width: 600px) and (max-width: 767px) {

}

@media (min-width: 768px) and (max-width: 991px) {

}

/* Medium devices (landscape tablets, 768px and up) */

/* Large devices (laptops/desktops, 992px and up) */
@media only screen and (min-width: 992px) {

}

/* Extra large devices (large laptops and desktops, 1200px and up) */
@media only screen and (min-width: 1200px) {
  .temp_10 {
    border: unset;
    width: 100%;
    min-height: 200px;
    border-radius: 10px;

  }

  .text_space {
    margin-top: 10px;
  }

  .imageSize {
    width: 4%;
  }

}
.logosize{
width:80px;
  border: 1px solid #eddede;
  border-radius: 45px;
  background: white;

}

.multigardgrid{
  border-radius: 4px;
  text-align: center;
  width: 100%;
  font-size: 15px;
  background: white;
}
.badgestyle{
  padding: 2px 13px;
  margin-left: 15px;
}
</style>
